import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core';

interface Props {
  name: string;
  path: string;
  icon: ReactElement;
}

const MenuItem: React.FC<Props> = (props) => {
  const { name, path, icon } = props;
  return (
    <Link to={path}>
      <ListItem button>
        <ListItemIcon>{icon}</ListItemIcon>
        <ListItemText primary={name} />
      </ListItem>
    </Link>
  );
};

export default MenuItem;
